import VoteServices from '../../services/Vote';
import * as mutationTypes from '../mutation-types';

export default function() {
    const state = {
        votedNominations: [],
    };

    const getters = {
        votedNominations: (newState) => newState.votedNominations,
    };

    const actions = {
        async proposeNominee({ commit, dispatch }, value) {
            dispatch('loader/increment', {}, { root: true });
            const isFetch = await VoteServices.proposeNominee(value);

            if (isFetch) {
                commit(mutationTypes.PROPOSE_NOMINEE_SUCCESS, value);
            } else {
                commit(mutationTypes.PROPOSE_NOMINEE_FAILURE);
            }

            dispatch('loader/decrement', {}, { root: true });
        },

        async fetchVotedNominations({ commit, dispatch }, params) {
            dispatch('loader/increment', {}, { root: true });
            const votedNominations = await VoteServices.fetchNominationsVoted(params);

            try {
                commit(mutationTypes.FETCH_VOTED_NOMINATION_SUCCESS, votedNominations);
            } catch (error) {
                commit(mutationTypes.FETCH_VOTED_NOMINATION_FAILURE, error);
            }

            dispatch('loader/decrement', {}, { root: true });
        },

        async voteNominee({ commit, dispatch }, params) {
            dispatch('loader/increment', {}, { root: true });
            const resultVoteNominee = await VoteServices.voteNominee(params);

            if (resultVoteNominee.status === 200) {
              commit(mutationTypes.VOTE_NOMINEE_SUCCESS, params);
            } else if (resultVoteNominee.status === 400) {
              commit(mutationTypes.VOTE_NOMINEE_CLOSED, params);
            } else {
              commit(mutationTypes.VOTE_NOMINEE_FAILURE);
            }

            dispatch('loader/decrement', {}, { root: true });
        },

        async clearVoteNominee({ commit }) {
          commit(mutationTypes.CLEAR_VOTED_NOMINATION);
        },
    };

    const mutations = {
        [mutationTypes.PROPOSE_NOMINEE_SUCCESS](state, data) {
            state.votedNominations.push({
                name: data.name,
                nominationId: Number(data.rubricId),
                id: Number(data.id)
            });

            if (window.fbq) window.fbq('track', 'AddToCart');
        },

        [mutationTypes.PROPOSE_NOMINEE_FAILURE](state) {
            state.error = 'Что то пошло не так, попробуйте еще раз!';
        },

        [mutationTypes.FETCH_VOTED_NOMINATION_SUCCESS](state, data) {
            if (data.length !== 0) {
                state.votedNominations = data;
            }
        },

        [mutationTypes.CLEAR_VOTED_NOMINATION](state) {
          state.votedNominations = [];
        },

        [mutationTypes.FETCH_VOTED_NOMINATION_FAILURE](state, error) {
            state.error = error;
        },

        [mutationTypes.VOTE_NOMINEE_SUCCESS](state, data) {
            state.votedNominations.push({
                name: data.name,
                nominationId: Number(data.rubricId),
                id: Number(data.nominantId),
                isRevoteAllowed: true
            });
        },

        [mutationTypes.VOTE_NOMINEE_CLOSED](state, data) {
          state.votedNominations.push({
            nominationId: Number(data.rubricId),
            id: Number(data.nominantId),
            isRevoteAllowed: false
          });
        },

        [mutationTypes.VOTE_NOMINEE_FAILURE](state, error) {
            state.error = error;
        },
    };

    return {
        namespaced: true,
        state,
        getters,
        actions,
        mutations,
    };
}



// WEBPACK FOOTER //
// ./src/store/modules/vote.js